import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const hasDownloadedCards = createSelector(creditCardsState, (creditCards) => creditCards.download?.downloadedDate != null);
